import UUID from "#/Utilities/Generic/UUID.ts";
import type { SubchannelCallback, SubchannelConnection } from "#/Workers/Socket/SubchannelConnection.ts";

export class Subchannel {
    private readonly id: string;

    constructor(
        private connection: SubchannelConnection
    ) {
        this.id = UUID.generate();
    }

    public addListener(type: string, callback: SubchannelCallback): void {
        this.connection.addListener(this.id, type, callback);
    }

    public removeListener(type: string, callback: SubchannelCallback): void {
        this.connection.removeListener(this.id, type, callback);
    }

    public connect(): void {
        this.connection.connect(this.id);

        this.updatePresence();
    }

    public disconnect(): void {
        this.connection.disconnect(this.id);
    }

    public sendMessage(event: string, message: any): void {
        this.connection.sendMessage(event, message);
    }

    public updatePresence(): void {
        this.connection.updatePresence();
    }
}
